"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstance = void 0;
const load_1 = require("./load");
let inst = null;
let instPromise = (async () => {
    inst = await load_1.loadWasmInstance({});
    if (!inst) {
        throw Error('WASM was not loaded');
    }
    return inst;
})();
exports.getInstance = async () => {
    return await instPromise;
};
//# sourceMappingURL=instance.js.map